

import { Action, Getter, namespace } from "vuex-class"
import { Component, Vue, Watch } from "vue-property-decorator"

// @ts-ignore
import vSelect from "vue-select"
import VuePerfectScrollbar from "vue-perfect-scrollbar"

import DataTable from "@/components/Config/DataTable.vue"
import FieldControl from "@/components/Fields/FieldControl.vue"
import SkeletonLoader from "@/components/SkeletonLoader.vue"

import api from "@/services/api"
import apiTenant from "@/services/api_Tenant"
import { CurrentUser } from "@/types/user"
import Guid from "@/scripts/guid"
import { insightDuplicationOptions } from "@/types/insights/insightDuplication"
import { TenantSettingKeys } from "@/types/tenantSetting"

const setup = namespace("setup")

@Component({
	components: {
		"v-select": vSelect,
		"scrollbar": VuePerfectScrollbar,
		"data-table": DataTable,
		"skeleton": SkeletonLoader,
		"field-control": FieldControl
	}
})
export default class TenantSettingsSetup extends Vue {
	@setup.Getter("getFieldTypes")
	private fieldTypes!: any[]

	@Getter("getMe")
	public currentUser!: CurrentUser;

	@Action("loadTenantSettings")
	private loadTenantSettings!: () => Promise<void>

	$refs!: {
		dataTable: DataTable
	};

	key: string = ""

	public items: Array<any> = []
	public settings: { [key: string]: any; } = {}

	public waiting: boolean = false

	public updates: { [ key: string]: any } = {}

	public get columns () {
		return [
			{
				key: "title",
				label: "Title"
			},
			{
				key: "description",
				label: "Description"
			},
			{
				key: "appropriateControl",
				label: "",
				hasTemplate: true
			}
		]
	}

	public get hasEditPermissions () {
		return this.currentUser.editData
	}

	public get hasUpdates (): boolean {
		return Object.keys(this.updates).length > 0
	}

	public async mounted () {
		await this.loadData()
	}

	private async loadData () {
		this.waiting = true
		const timezones = await api.timeZonesGet()

		this.items = (await apiTenant.getTenantSettings())
			.filter(f => f.setting && f.setting.hideFromSetupPage !== true)
			.map(item => {
				const setting = {
					id: item.setting.key,
					title: item.setting.title,
					description: item.setting.description,
					dataType: item.setting.dataType,
					value: item.value,
					options: [] as any[],
					placeholder: null as (string | null)
				}

				if (setting.id === TenantSettingKeys.EnabledTimezones) {
					setting.options = timezones
					setting.placeholder = "All timezones allowed"
				}
				if (setting.id === TenantSettingKeys.DoNotDuplicateInsightOptionDefaults) {
					setting.options = insightDuplicationOptions
					setting.placeholder = "All options duplicated"
				}

				return setting
			})
		this.waiting = false

		this.updates = {}
		this.key = Guid.newGuid().toString()
	}

	private showToast (message: string, title: string, variant: string) {
		this.$bvToast.toast(message, {
			title: title,
			variant: variant,
			solid: true,
			autoHideDelay: 5000
		})
	}

	public makeChange (key: string, value: any) {
		Vue.set(this.updates, key, value)
	}

	public async apply () {
		await apiTenant.saveTenantSettings(this.updates)
		this.updates = {}

		this.showToast("General Settings have been saved", "Success", "success")
		this.loadData()

		// Force refresh on tenant settings
		this.loadTenantSettings()
	}

	public revert () {
		this.loadData()
	}
}
